<!-- Affected API Flow Section -->
<div *ngFor="let section of sections">
  <h2>{{ section.title }}</h2>
  <div class="mb-30" *ngFor="let singleArrowItem of section.bodyArrows">
    <div class="tb" *ngFor="let arrowText of singleArrowItem.split(';'); let i = index">
      <div>
        <div *ngIf="isFareBandNameAndCodeOrderReshopPage && i === 0" class="saw-tooth-vertical">&nbsp;</div>
        <div *ngIf="isAPIFlow && i === 0">&nbsp;</div>
        <div
          class="arrow"
          [ngClass]="{
            'bg-color-1': i === 0,
            'bg-color-2': i === 1,
            'bg-color-3': i === 2,
            'bg-color-4': i === 3,
            'bg-color-5': i === 4,
            'bg-color-6': i === 5,
            'bg-color-7': i === 6,
            'bg-color-8': i === 7,
            'bg-color-9': i === 8,
            'bg-color-10': i === 9
          }"
        >
          <div class="coltxt">
            {{ arrowText }}
          </div>
        </div>
        <div class="arrow">
          <div
            class="triangle-right"
            [ngClass]="{
              'square-color-1': i === 0,
              'square-color-2': i === 1,
              'square-color-3': i === 2,
              'square-color-4': i === 3,
              'square-color-5': i === 4,
              'square-color-6': i === 5,
              'square-color-7': i === 6,
              'square-color-8': i === 7,
              'square-color-9': i === 8,
              'square-color-10': i === 9
            }"
            [ngStyle]="{ 'background-color': i === singleArrowItem.split(';').length - 1 ? 'white' : '' }"
          >
            &nbsp;
          </div>
        </div>
        <!-- <div class="saw-tooth-vertical">&nbsp;</div>  -->
      </div>
    </div>
  </div>
  <div>
    {{ section.subBody }}
  </div>
</div>
